import { TableCell } from "@mui/material"
import type { FC } from "react"

import { InventoryLotStatusIcon } from "../InventoryLotStatusIcon"

import type { InventoryPalletLot, ProductPackagingType } from "@/graphql/codegen/graphql"
import { formatNumber } from "@/utils/number"
import { calculateRemainingShelfLife, getProductPackagingTypeLabel } from "@/utils/product"
import { isNil } from "@/utils/utils"

interface InventoryLotTableRowCellsProps {
  lot: InventoryPalletLot
  uomName: string
  showStatusIcon?: boolean
}

export const InventoryLotTableRowCells: FC<InventoryLotTableRowCellsProps> = ({
  lot,
  uomName,
  showStatusIcon = true,
}) => {
  const remainingShelfLife = calculateRemainingShelfLife(lot.manufacturingDate, lot.expirationDate)

  return (
    <>
      <TableCell>
        {showStatusIcon ? (
          <div className='flex items-center gap-x-1'>
            <InventoryLotStatusIcon qaStatus={lot.qaStatus} />
            {lot.lotNbr ?? ""}
          </div>
        ) : (
          (lot.lotNbr ?? "")
        )}
      </TableCell>
      <TableCell>{lot.batchNbr ?? ""}</TableCell>
      <TableCell className='whitespace-nowrap'>{isNil(remainingShelfLife) ? "" : `${remainingShelfLife} %`}</TableCell>
      <TableCell>{getProductPackagingTypeLabel(lot.packageDesc as ProductPackagingType)}</TableCell>
      <TableCell>{lot.totalPackages}</TableCell>
      <TableCell className='whitespace-nowrap'>
        {isNil(lot.packageSize) ? "" : `${formatNumber(lot.packageSize)} ${uomName}`}
      </TableCell>
      <TableCell className='whitespace-nowrap'>
        {isNil(lot.totalUnits) ? "" : `${formatNumber(lot.totalUnits)} ${uomName}`}
      </TableCell>
    </>
  )
}
